module.exports = __webpack_public_path__ + "img/order@2x.d2e55763.png";